import dynamicFromItem from '../dynamicFrom/dynamicFromItem'
import FormItem from '../dynamicFrom/form-item'
import dynamicItemUtil from '../dynamicFrom/libs/dynamicItemUtil'
import compileVariableUtil from '../../static/js/compileVariableUtil'
import templateUtil from '../../static/js/templateUtil'
import objectUtil from '../../static/js/objectUtil'
const get = objectUtil.getValueByPath
const set = objectUtil.setValueByPath

// 采用dynamicFromItem包装验证框架的组件数组
const dynamicFromItemArr = ['addressInfoEdit', 'addressEdit', 'proportionInput']

export default {
  name: 'formItemRender',
  components: {
    dynamicFromItem,
    FormItem,
  },
  props: {
    store: {
      type: Object,
      default: null,
    },
    formItem: {
      type: Object,
      default: null,
    },
    data: {
      type: Object,
      default: null,
    },
    extendData: {
      type: Object,
      default: null,
    },
    idPrefix: {
      type: String,
      default: 'idPrefix',
    },
  },
  methods: {
    /**
      包装到验证框架itemform中。
      @param {function} render 渲染方法
      @param {object} editformItem 元素定义
      @param {array} children 子元素列表

    */
    createItemForm(h, editformItem, style, children) {
      var propsData = {
        key: editformItem.property + editformItem.label,
        prop: editformItem.property,
        label: editformItem.label,
        rules: editformItem.required
          ? editformItem.validate
          : editformItem.validate.map((item) => {
              item.required = false
              return item
            }),
      }

      // 转换显示的值
      const convertValue = (val) => {
        if (val === '__NOT_SHOW__') return // 如果接口没返回该字段，则不显示高亮
        if (val === 0 || val === '0') return '0'
        if (val === true) return '是'
        if (val === false) return '否'
        if (val === '' || val == undefined) return '-'
        if (Array.isArray(val) && !val.length) return '-'

        return val
      }
      // 可显示修改历史记录的组件
      const arr = ['readText', 'cellBoolean', 'arrToStr']
      if (arr.includes(editformItem.component.code)) {
        if (editformItem.old?.status) {
          const __IS_NOT_SHOW__ = editformItem.old.value === '__NOT_SHOW__'
          children.push(
            h(
              'span',
              {
                style: {
                  ...style,
                  border: !__IS_NOT_SHOW__ ? '1px dashed #ff0000' : undefined,
                  backgroundColor: !__IS_NOT_SHOW__ ? 'rgba(255, 0, 0, 0.05)' : undefined,
                  padding: '3px',
                  'font-size': '14px',
                  'border-radius': '6px',
                },
              },
              [convertValue(editformItem.old.value)]
            )
          )
        }
      }

      return h(
        'form-item',
        {
          style,
          props: propsData,
        },
        children
      )
    },
    /**
      包装到验证框架dynamicFromItem中。
      @param {function} render 渲染方法
      @param {object} editformItem 元素定义
      @param {array} children 子元素列表

    */
    createDynamicFromItem(h, editformItem, style, children) {
      var propsData = {
        key: editformItem.property + editformItem.label,
        prop: editformItem.property,
        label: editformItem.label,
        rules: editformItem.required
          ? editformItem.validate
          : editformItem.validate.map((item) => {
              item.required = false
              return item
            }),
      }
      return h(
        'dynamic-from-item',
        {
          style,
          props: propsData,
        },
        children
      )
    },
    /**
     * 包装历史修改记录
     * @param {function} h 渲染方法
     * @param {object} vNodeFn 组件节点
     * @param {string} componentName 组件名称
     * @param {object} editformItem 元素定义
     * @param {object} propsCompile 组件属性
     * @param {object} style 组件样式
     * @returns {object} 组件节点
     */
    createHistoryItem(h, vNodeFn, componentName, editformItem, propsCompile, style) {
      const __IS_NOT_SHOW__ = editformItem.old.value === '__NOT_SHOW__'
      if (__IS_NOT_SHOW__) return vNodeFn

      const vTitleNodeFn = h(
        'h3',
        {
          style: {
            fontSize: '14px',
            margin: '10px 20px',
          },
        },
        ['上一次' + editformItem.name]
      )
      const vOldNodeFn = h(componentName, {
        attrs: {
          id: `OLD_${this.idPrefix}_${editformItem.code}`,
          title: undefined,
        },
        style: { ...style },
        props: {
          ...propsCompile,
          store: this.store,
          value: get(editformItem, 'old.value'),
        },
      })

      return h('div', {}, [vNodeFn, vTitleNodeFn, vOldNodeFn])
    },
  },
  render(h) {
    const componentName = dynamicItemUtil.convertComponentName(this.formItem?.component?.code)
    const compileData = compileVariableUtil.getCompileVariable(this.data, this, this.extendData)
    const parameter = this.formItem?.parameter ?? {}
    const { changeBorthers, onBlur, isFormItem, ...componentProps } = parameter
    const propsCompile = templateUtil.compileData(componentProps, compileData)
    //支持是否显示和显示表达式
    const showRegex = this.formItem.show
      ? templateUtil.compileData(this.formItem.show, compileData)
      : true
    if (!this.formItem.visible || !showRegex) {
      return null
    }
    //当为input组件时支持设置maxlength
    if (this.formItem.length > 0 && ~['input', 'i-input', 'Input'].indexOf(componentName)) {
      propsCompile.maxlength = propsCompile.maxlength ?? this.formItem.length
    }
    if (this.formItem.disabled) {
      propsCompile.disabled = this.formItem.disabled
    }
    const onEvent = {
      input: (val) => {
        set(this.data, this.formItem.property, val)
        this.$emit('form-item-change', val, this.formItem.property)
        if (changeBorthers) {
          let temp = {}
          Object.keys(changeBorthers).forEach((im) => {
            let otherFields = changeBorthers[im]
            if (!otherFields) {
              temp[im] = otherFields
            } else if (otherFields.startsWith('{{') && otherFields.endsWith('}}')) {
              temp[im] = templateUtil.compileData(otherFields, compileData)
            } else {
              temp[im] = objectUtil.getValueByPath(val, otherFields)
            }
          })
          Object.keys(temp).forEach((im) => {
            set(this.data, im, temp[im])
            // objectUtil.setValueByPathForVue(this.data, im, temp[im], _vm)
          })
        }
      },
    }

    if (onBlur) {
      onEvent['on-blur'] = () => {
        let newValue = objectUtil.getValueByPath(this.data, this.formItem.property)
        this.$emit('on-blur', newValue, this.formItem.property)
      }
    }
    if (componentName == 'panguInputNumber' || componentName == 'i-input') {
      onEvent['on-enter'] = () => {
        let newValue = objectUtil.getValueByPath(this.data, this.formItem.property)
        this.$emit('on-enter', newValue, this.formItem.property)
      }
    }

    if (
      componentName === 'readText' &&
      !Object.prototype.hasOwnProperty.call(propsCompile, 'title')
    ) {
      propsCompile.title = true
    }

    let vNodeFn = h(componentName, {
      attrs: {
        id: `${this.idPrefix}_${this.formItem.code}`,
        title:
          componentName === 'i-input' &&
          propsCompile?.type !== 'textarea' &&
          propsCompile?.type !== 'password'
            ? get(this.data, this.formItem.property)
            : undefined,
      },
      props: {
        ...propsCompile,
        store: this.store,
        value: propsCompile.value ?? get(this.data, this.formItem.property),
      },
      on: onEvent, // 增加事件监听
    })
    const RenderFormItem = !this.formItem.label ? isFormItem ?? false : true
    if (dynamicFromItemArr.indexOf(componentName) > -1) {
      vNodeFn = this.createDynamicFromItem(
        h,
        this.formItem,
        templateUtil.compileData(this.formItem.style, compileData),
        [vNodeFn]
      )
    } else if (RenderFormItem) {
      vNodeFn = this.createItemForm(
        h,
        this.formItem,
        templateUtil.compileData(this.formItem.style, compileData),
        [vNodeFn]
      )
    }

    // #9708 历史记录支持表格
    if (['crudArray'].includes(componentName)) {
      if (this.formItem.old?.status) {
        vNodeFn = this.createHistoryItem(h, vNodeFn, componentName, this.formItem, propsCompile, {})
      }
    }

    return vNodeFn
  },
}
